import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const TableSkeletonRow = () => (
  <tr style={{ height: '3rem' }}>
    <td style={{ padding: '0.5rem', border: 'none' }}>
      <Skeleton width="2rem" height="1.5rem" />
    </td>
    <td
      style={{
        padding: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        border: 'none',
      }}
    >
      <Skeleton variant="circular" width="2rem" height="2rem" />
      <Skeleton width="8rem" height="1.5rem" />
    </td>
    <td
      style={{
        padding: '0.5rem',
        width: '6rem',
        textAlign: 'right',
        border: 'none',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Skeleton width="4rem" height="1.5rem" />
      </div>
    </td>
  </tr>
);

export function LeaderboardV2TableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div
      className="qlfeditor-leaderboard__table--skeleton qlf-skeleton"
      style={{ overflowX: 'auto' }}
      data-testid="skeleton"
      role="status"
      aria-live="polite"
      // not translated as this is backend rendered and while we have the locale at hand, it's not handy to make i18next work with SSR
      aria-label="Loading leaderboard"
    >
      <Skeleton height="2rem" width="100%" sx={{ marginBottom: '0.5rem' }} variant="rectangular" />
      <table className="qlf-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <TableSkeletonRow key={i} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
